module.exports = __webpack_public_path__ + "static/img/9.5a4f302.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/zh/9.png
// module id = yy3A
// module chunks = 0